export default "__VITE_ASSET__4b48cf73__"